import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { XMarkIcon } from '@heroicons/react/24/outline';
const SIZE = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl',
};
export function Modal({ open, onClose, title, children, footer, size = 'md' }) {
    useEffect(() => {
        if (!open)
            return;
        const h = (e) => { if (e.key === 'Escape')
            onClose(); };
        document.addEventListener('keydown', h);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', h);
            document.body.style.overflow = '';
        };
    }, [open, onClose]);
    return createPortal(_jsx(AnimatePresence, { children: open && (_jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, className: "fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm", onClick: onClose, children: _jsxs(motion.div, { initial: { opacity: 0, scale: 0.96, y: 10 }, animate: { opacity: 1, scale: 1, y: 0 }, exit: { opacity: 0, scale: 0.96, y: 10 }, transition: { duration: 0.15 }, onClick: (e) => e.stopPropagation(), className: `w-full ${SIZE[size]} overflow-hidden rounded-2xl bg-white shadow-2xl dark:bg-gray-900`, children: [_jsxs("div", { className: "flex items-center justify-between border-b border-gray-200 px-5 py-3 dark:border-gray-800", children: [_jsx("h2", { className: "text-base font-semibold text-gray-900 dark:text-gray-100", children: title }), _jsx("button", { onClick: onClose, className: "rounded-md p-1 text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800", children: _jsx(XMarkIcon, { className: "h-5 w-5" }) })] }), _jsx("div", { className: "max-h-[70vh] overflow-y-auto px-5 py-4", children: children }), footer && (_jsx("div", { className: "flex items-center justify-end gap-2 border-t border-gray-200 bg-gray-50 px-5 py-3 dark:border-gray-800 dark:bg-gray-950", children: footer }))] }) })) }), document.body);
}
